<div class="aca-admin aca-inst">
  <!-- breadcrumb -->
  <nav class="aca-task__crumbs" aria-label="breadcrumb">
    <a routerLink="/" class="aca-task__crumbhome" [attr.aria-label]="'DMS.NAV.HOME' | translate"><mat-icon>home</mat-icon></a>
    <mat-icon class="aca-task__crumbsep">chevron_right</mat-icon>
    <a routerLink="/workflows/track" class="aca-task__crumblink">{{ 'DMS.INST.TRACK' | translate }}</a>
    <mat-icon class="aca-task__crumbsep">chevron_right</mat-icon>
    <span class="aca-task__crumbhere">{{ 'DMS.INST.DETAIL' | translate }}</span>
  </nav>

  <mat-progress-bar mode="indeterminate" *ngIf="loading()" />

  <aca-page-state
    *ngIf="!loading() && !proc()"
    state="error"
    icon="error_outline"
    [title]="'DMS.INST.NOT_FOUND' | translate"
    [message]="'DMS.INST.NOT_FOUND_HINT' | translate"
  />

  <ng-container *ngIf="proc() as p">
    <!-- header card -->
    <section class="aca-inst__head">
      <span class="aca-inst__headicon"><mat-icon>description</mat-icon></span>
      <div class="aca-inst__headmain">
        <div class="aca-inst__headline">
          <h2 class="aca-inst__title">WF-{{ p.id }}</h2>
          <span class="aca-inst__status" [ngClass]="'aca-inst__status--' + statusKey()">
            <mat-icon>{{
              statusKey() === 'running'
                ? 'play_circle'
                : statusKey() === 'rejected'
                  ? 'undo'
                  : statusKey() === 'cancelled'
                    ? 'cancel'
                    : 'check_circle'
            }}</mat-icon
            >{{ 'DMS.INST.S_' + statusKey().toUpperCase() | translate }}
          </span>
        </div>
        <p class="aca-inst__subtitle" *ngIf="flowDesc()">{{ flowDesc() }}</p>
        <div class="aca-inst__headfacts">
          <span class="aca-inst__headfact">
            <mat-icon>event</mat-icon>
            <span
              ><small>{{ 'DMS.INST.STARTED' | translate }}</small
              >{{ (p.startedAt | acaDate: 'd MMM y HH:mm') || '—' }}</span
            >
          </span>
          <span class="aca-inst__headfact">
            <mat-icon>person</mat-icon>
            <span
              ><small>{{ 'DMS.INST.STARTED_BY' | translate }}</small
              >{{ p.startUserId || '—' }}</span
            >
          </span>
          <span class="aca-inst__headfact">
            <mat-icon>account_tree</mat-icon>
            <span
              ><small>{{ 'DMS.INST.DEF_VER' | translate }}</small
              >v{{ wfVersion() }} · {{ flowName() }}</span
            >
          </span>
        </div>
      </div>
      <button type="button" class="aca-inst__docbtn" *ngIf="canCancel()" (click)="cancel()" [disabled]="cancelling()">
        <mat-icon>cancel</mat-icon>{{ 'DMS.INST.CANCEL' | translate }}
      </button>
      <button type="button" class="aca-inst__docbtn" *ngIf="items().length" (click)="openDoc(items()[0])">
        <mat-icon>description</mat-icon>{{ 'DMS.INST.VIEW_DOC' | translate }}
      </button>
    </section>

    <!-- tabs -->
    <div class="aca-inst__tabs" role="tablist">
      <button type="button" role="tab" class="aca-inst__tab" [class.aca-inst__tab--on]="tab() === 'steps'" (click)="tab.set('steps')">
        <mat-icon>account_tree</mat-icon>{{ 'DMS.INST.TAB_STEPS' | translate }}
      </button>
      <button type="button" role="tab" class="aca-inst__tab" [class.aca-inst__tab--on]="tab() === 'info'" (click)="tab.set('info')">
        <mat-icon>article</mat-icon>{{ 'DMS.INST.TAB_INFO' | translate }}
      </button>
      <button type="button" role="tab" class="aca-inst__tab" [class.aca-inst__tab--on]="tab() === 'docs'" (click)="tab.set('docs')">
        <mat-icon>attach_file</mat-icon>{{ 'DMS.INST.TAB_DOCS' | translate }}
      </button>
      <button type="button" role="tab" class="aca-inst__tab" [class.aca-inst__tab--on]="tab() === 'history'" (click)="tab.set('history')">
        <mat-icon>history</mat-icon>{{ 'DMS.INST.TAB_HISTORY' | translate }}
      </button>
    </div>

    <div class="aca-inst__body">
      <div class="aca-inst__main">
        <!-- steps table -->
        <section class="aca-inst__card" *ngIf="tab() === 'steps'">
          <h3 class="aca-inst__cardtitle">{{ 'DMS.INST.STEPS_TITLE' | translate }}</h3>
          <table class="aca-inst__steptable">
            <thead>
              <tr>
                <th>{{ 'DMS.INST.COL_STEP' | translate }}</th>
                <th>{{ 'DMS.INST.COL_STATE' | translate }}</th>
                <th>{{ 'DMS.INST.COL_AT' | translate }}</th>
                <th>{{ 'DMS.INST.COL_WHO' | translate }}</th>
                <th>{{ 'DMS.INST.COL_NOTE' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let s of timeline(); let i = index; let last = last"
                data-automation-id="dms-inst-step"
                [ngClass]="'aca-inst__srow--' + s.state"
              >
                <td class="aca-inst__stepcell">
                  <span class="aca-inst__steprail">
                    <span class="aca-inst__stepdot" [ngClass]="'aca-inst__stepdot--' + s.state">
                      <mat-icon *ngIf="s.state === 'done'">check</mat-icon>
                    </span>
                    <span class="aca-inst__stepline" *ngIf="!last"></span>
                  </span>
                  <span class="aca-inst__stepname">
                    <b>{{ i + 1 }}. {{ s.name | translate }}</b>
                    <small *ngIf="s.desc">{{ s.desc | translate }}</small>
                  </span>
                </td>
                <td>
                  <span class="aca-inst__state" [ngClass]="'aca-inst__state--' + s.state">
                    <mat-icon>{{ s.state === 'done' ? 'check_circle' : s.state === 'active' ? 'play_circle' : 'schedule' }}</mat-icon
                    >{{ 'DMS.INST.TS_' + s.state.toUpperCase() | translate }}
                  </span>
                </td>
                <td class="aca-inst__at">{{ (s.at | acaDate: 'd MMM y HH:mm') || '—' }}</td>
                <td class="aca-inst__who">{{ s.who || '—' }}</td>
                <td class="aca-inst__note">{{ s.note ? (s.note | translate) : '—' }}</td>
              </tr>
            </tbody>
          </table>
        </section>

        <!-- general info -->
        <section class="aca-inst__card" *ngIf="tab() === 'info'">
          <dl class="aca-inst__props">
            <dt>{{ 'DMS.INST.DESCRIPTION' | translate }}</dt>
            <dd>{{ variables()['bpm_workflowDescription'] || '—' }}</dd>
            <dt>{{ 'DMS.INST.PRIORITY' | translate }}</dt>
            <dd>{{ variables()['bpm_priority'] ?? '—' }}</dd>
            <dt>{{ 'DMS.INST.DUE' | translate }}</dt>
            <dd>{{ (variables()['bpm_workflowDueDate'] | acaDate: 'd MMM y') || '—' }}</dd>
            <dt>{{ 'DMS.INST.DEF_KEY' | translate }}</dt>
            <dd class="aca-inst__mono">{{ p.processDefinitionId || p.processDefinitionKey }}</dd>
          </dl>
        </section>

        <!-- documents -->
        <section class="aca-inst__card" *ngIf="tab() === 'docs'">
          <ul class="aca-inst__docs" *ngIf="items().length; else noItems">
            <li *ngFor="let d of items()">
              <button type="button" class="aca-inst__docrow" (click)="openDoc(d)">
                <span class="aca-file" [ngClass]="fileClass(d.name)"
                  ><mat-icon>{{ fileIcon(d.name) }}</mat-icon></span
                >
                <span class="aca-inst__docmeta">
                  <b>{{ d.name }}</b>
                  <small>{{ sizeText(d.size) }} · {{ (d.createdAt | acaDate: 'd MMM y HH:mm') || '—' }}</small>
                </span>
                <mat-icon class="aca-inst__docgo">chevron_right</mat-icon>
              </button>
            </li>
          </ul>
          <ng-template #noItems
            ><p class="aca-inst__empty">{{ 'DMS.INST.NO_DOCS' | translate }}</p></ng-template
          >
        </section>

        <!-- history -->
        <section class="aca-inst__card" *ngIf="tab() === 'history'">
          <ol class="aca-inst__history" *ngIf="tasks().length; else noHist">
            <li *ngFor="let t of tasks()">
              <span class="aca-inst__histtime">{{ (t.endedAt ?? t.startedAt | acaDate: 'd MMM y HH:mm') || '—' }}</span>
              <span class="aca-inst__histname">{{ t.name }}</span>
              <span class="aca-inst__histby" *ngIf="t.assignee">{{ t.assignee }}</span>
              <span class="aca-inst__state" [ngClass]="t.state === 'completed' ? 'aca-inst__state--done' : 'aca-inst__state--active'">
                <mat-icon>{{ t.state === 'completed' ? 'check_circle' : 'play_circle' }}</mat-icon
                >{{ 'DMS.INST.TS_' + (t.state === 'completed' ? 'DONE' : 'ACTIVE') | translate }}
              </span>
            </li>
          </ol>
          <ng-template #noHist
            ><p class="aca-inst__empty">{{ 'DMS.INST.NO_HISTORY' | translate }}</p></ng-template
          >
        </section>
      </div>

      <!-- right rail -->
      <aside class="aca-inst__rail">
        <section class="aca-inst__card">
          <h3 class="aca-inst__cardtitle">{{ 'DMS.INST.SUMMARY' | translate }}</h3>
          <ul class="aca-inst__sumlist">
            <li>
              <mat-icon>account_tree</mat-icon>
              <span class="aca-inst__sumtext"
                ><small>{{ 'DMS.INST.F_WF' | translate }}</small
                ><b>{{ flowName() }}</b></span
              >
            </li>
            <li>
              <mat-icon>sell</mat-icon>
              <span class="aca-inst__sumtext"
                ><small>{{ 'DMS.INST.F_VER' | translate }}</small
                ><b>v{{ instance()?.templateVersion ?? wfVersion() }}</b></span
              >
            </li>
            <li>
              <button type="button" class="aca-inst__sumlink" (click)="tab.set('docs')">
                <mat-icon>description</mat-icon>
                <span class="aca-inst__sumtext"
                  ><small>{{ 'DMS.INST.TAB_DOCS' | translate }}</small
                  ><b>{{ 'DMS.INST.N_ITEMS' | translate: { p0: items().length } }}</b></span
                >
                <mat-icon class="aca-inst__sumgo">chevron_right</mat-icon>
              </button>
            </li>
            <li>
              <mat-icon>person</mat-icon>
              <span class="aca-inst__sumtext"
                ><small>{{ 'DMS.INST.F_WHO_NOW' | translate }}</small
                ><b>{{ currentAssignee() }}</b></span
              >
            </li>
            <li>
              <mat-icon>schedule</mat-icon>
              <span class="aca-inst__sumtext"
                ><small>{{ 'DMS.INST.F_ELAPSED' | translate }}</small
                ><b>{{ 'DMS.INST.ELAPSED_FMT' | translate: elapsed() }}</b>
                <small>{{ 'DMS.INST.START_PREFIX' | translate }} {{ p.startedAt | acaDate: 'd MMM y HH:mm' }}</small></span
              >
            </li>
          </ul>
          <button type="button" class="aca-inst__primary" *ngIf="activeTask() && !p.completed" (click)="openTask(activeTask()!.id)">
            <mat-icon>open_in_new</mat-icon>{{ 'DMS.INST.OPEN_TASK' | translate }}
          </button>
        </section>

        <section class="aca-inst__card" *ngIf="items().length">
          <h3 class="aca-inst__cardtitle aca-inst__cardtitle--row">
            {{ 'DMS.INST.TAB_DOCS' | translate }}
            <button type="button" class="aca-inst__seeall" (click)="tab.set('docs')">
              {{ 'DMS.INST.SEE_ALL' | translate }}<mat-icon>chevron_right</mat-icon>
            </button>
          </h3>
          <ul class="aca-inst__docs">
            <li *ngFor="let d of items()">
              <button type="button" class="aca-inst__docrow" (click)="openDoc(d)">
                <span class="aca-file" [ngClass]="fileClass(d.name)"
                  ><mat-icon>{{ fileIcon(d.name) }}</mat-icon></span
                >
                <span class="aca-inst__docmeta">
                  <b>{{ d.name }}</b>
                  <small>{{ sizeText(d.size) }} · {{ (d.createdAt | acaDate: 'd MMM y HH:mm') || '—' }}</small>
                </span>
                <mat-icon class="aca-inst__docgo">chevron_right</mat-icon>
              </button>
            </li>
          </ul>
        </section>
      </aside>
    </div>
  </ng-container>
</div>
